// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LanguageTab__parentItems___2qSVM{overflow-x:auto}.LanguageTab__hybridItem___1C4qA.LanguageTab__expand___3SCaZ{flex:1}.LanguageTab__hasError___2Rjus{position:relative}.LanguageTab__hasError___2Rjus::after{content:'';position:absolute;width:4px;height:4px;border-radius:50%;background:#f00;right:-8px}.languageTabSlider-arrow{box-shadow:none !important;border:none;height:30px;width:70px;border-radius:0px}\n", ""]);
// Exports
exports.locals = {
	"parentItems": "LanguageTab__parentItems___2qSVM",
	"hybridItem": "LanguageTab__hybridItem___1C4qA",
	"expand": "LanguageTab__expand___3SCaZ",
	"hasError": "LanguageTab__hasError___2Rjus"
};
module.exports = exports;
